export default __webpack_public_path__ + "static/media/sam-and-karen-drenched-hiking2.98fbaf07.jpeg";